"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelect = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _language = require("../../language");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var LanguageSelect = (0, _styledComponents.default)(_language.LanguageSelect)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 191px;\n"])));
exports.LanguageSelect = LanguageSelect;